<div class="z-20" [ngClass]="{ 'dark text-white-dark': store.semidark && store.menu === 'horizontal'}">
    <div class="relative flex w-full items-center px-5 py-2.5">
        <div class="horizontal-logo flex min-w-0 items-center gap-2 ltr:mr-2 rtl:ml-2 lg:hidden">
            <app-workspace-switcher class="min-w-0 flex-1" />
            <a
                href="javascript:;"
                class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary"
                (click)="storeData.dispatch({type: 'toggleSidebar'})"
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 7L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path opacity="0.5" d="M20 12L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M20 17L4 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </a>
        </div>
        <!-- <div class="hidden ltr:mr-2 rtl:ml-2 sm:block">
            <ul class="flex items-center space-x-2 rtl:space-x-reverse dark:text-[#d0d2d6]">
                <li>
                    <a
                        routerLink="/calendar"
                        class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                            />
                            <path opacity="0.5" d="M7 4V2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            <path opacity="0.5" d="M17 4V2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            <path opacity="0.5" d="M2 9H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </a>
                </li>
                <li>
                    <a
                        routerLink="/apps/todolist"
                        class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                opacity="0.5"
                                d="M22 10.5V12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2H13.5"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                            <path
                                d="M17.3009 2.80624L16.652 3.45506L10.6872 9.41993C10.2832 9.82394 10.0812 10.0259 9.90743 10.2487C9.70249 10.5114 9.52679 10.7957 9.38344 11.0965C9.26191 11.3515 9.17157 11.6225 8.99089 12.1646L8.41242 13.9L8.03811 15.0229C7.9492 15.2897 8.01862 15.5837 8.21744 15.7826C8.41626 15.9814 8.71035 16.0508 8.97709 15.9619L10.1 15.5876L11.8354 15.0091C12.3775 14.8284 12.6485 14.7381 12.9035 14.6166C13.2043 14.4732 13.4886 14.2975 13.7513 14.0926C13.9741 13.9188 14.1761 13.7168 14.5801 13.3128L20.5449 7.34795L21.1938 6.69914C22.2687 5.62415 22.2687 3.88124 21.1938 2.80624C20.1188 1.73125 18.3759 1.73125 17.3009 2.80624Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                            />
                            <path
                                opacity="0.5"
                                d="M16.6522 3.45508C16.6522 3.45508 16.7333 4.83381 17.9499 6.05034C19.1664 7.26687 20.5451 7.34797 20.5451 7.34797M10.1002 15.5876L8.4126 13.9"
                                stroke="currentColor"
                                stroke-width="1.5"
                            />
                        </svg>
                    </a>
                </li>
                <li>
                    <a
                        routerLink="/chat"
                        class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle r="3" transform="matrix(-1 0 0 1 19 5)" stroke="currentColor" stroke-width="1.5" />
                            <path
                                opacity="0.5"
                                d="M14 2.20004C13.3538 2.06886 12.6849 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                        </svg>
                    </a>
                </li>
            </ul>
        </div> -->
        <div
            class="flex items-center space-x-1.5 ltr:ml-auto rtl:mr-auto rtl:space-x-reverse dark:text-[#d0d2d6] sm:flex-1 ltr:sm:ml-0 sm:rtl:mr-0 lg:space-x-2"
        >
            <div class="sm:ltr:mr-auto sm:rtl:ml-auto">
                <app-search-input
                    class="hidden sm:block sm:w-full sm:max-w-md"
                    wrapperClass="relative w-full max-w-md"
                    inputClass="form-input w-full cursor-pointer rounded-full border border-border bg-gray-100 py-1.5 pl-9 pr-4 text-sm text-black/60 transition hover:border-white-light hover:bg-white-light/80 dark:border-gray-600 dark:bg-dark/40 dark:text-white-dark/70 dark:hover:border-white/10 dark:hover:bg-dark/60"
                    placeholder="Search..."
                    shortcutLabel="Ctrl/Cmd+K"
                    [readOnly]="true"
                    [clearable]="false"
                    [pinnedExpanded]="paletteService.isOpen()"
                    (activate)="openCommandPalette($event)"
                />

                <button
                    type="button"
                    class="search_btn rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 dark:bg-dark/40 dark:hover:bg-dark/60 sm:hidden"
                    aria-label="Open global search"
                    (click)="openCommandPalette($event)"
                >
                    <svg
                        class="mx-auto h-4.5 w-4.5 dark:text-[#d0d2d6]"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="11.5" cy="11.5" r="9.5" stroke="currentColor" stroke-width="1.5" opacity="0.5" />
                        <path d="M18.5 18.5L22 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </button>
            </div>
            <div>
                <a
                    href="javascript:;"
                    *ngIf="store.theme === 'light'"
                    class="flex items-center rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    (click)="setTheme('dark')"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="1.5" />
                        <path d="M12 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M12 20V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M4 12L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M22 12L20 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M19.7778 4.22266L17.5558 6.25424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M4.22217 4.22266L6.44418 6.25424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M6.44434 17.5557L4.22211 19.7779" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M19.7778 19.7773L17.5558 17.5551" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </a>
                <a
                    href="javascript:;"
                    *ngIf="store.theme === 'dark'"
                    class="flex items-center rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    (click)="setTheme('system')"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M21.0672 11.8568L20.4253 11.469L21.0672 11.8568ZM12.1432 2.93276L11.7553 2.29085V2.29085L12.1432 2.93276ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM15.5 14.25C12.3244 14.25 9.75 11.6756 9.75 8.5H8.25C8.25 12.5041 11.4959 15.75 15.5 15.75V14.25ZM20.4253 11.469C19.4172 13.1373 17.5882 14.25 15.5 14.25V15.75C18.1349 15.75 20.4407 14.3439 21.7092 12.2447L20.4253 11.469ZM9.75 8.5C9.75 6.41182 10.8627 4.5828 12.531 3.57467L11.7553 2.29085C9.65609 3.5593 8.25 5.86509 8.25 8.5H9.75ZM12 2.75C11.9115 2.75 11.8077 2.71008 11.7324 2.63168C11.6686 2.56527 11.6538 2.50244 11.6503 2.47703C11.6461 2.44587 11.6482 2.35557 11.7553 2.29085L12.531 3.57467C13.0342 3.27065 13.196 2.71398 13.1368 2.27627C13.0754 1.82126 12.7166 1.25 12 1.25V2.75ZM21.7092 12.2447C21.6444 12.3518 21.5541 12.3539 21.523 12.3497C21.4976 12.3462 21.4347 12.3314 21.3683 12.2676C21.2899 12.1923 21.25 12.0885 21.25 12H22.75C22.75 11.2834 22.1787 10.9246 21.7237 10.8632C21.286 10.804 20.7293 10.9658 20.4253 11.469L21.7092 12.2447Z"
                            fill="currentColor"
                        />
                    </svg>
                </a>
                <a
                    href="javascript:;"
                    *ngIf="store.theme === 'system'"
                    class="flex items-center rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    (click)="setTheme('light')"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 9C3 6.17157 3 4.75736 3.87868 3.87868C4.75736 3 6.17157 3 9 3H15C17.8284 3 19.2426 3 20.1213 3.87868C21 4.75736 21 6.17157 21 9V14C21 15.8856 21 16.8284 20.4142 17.4142C19.8284 18 18.8856 18 17 18H7C5.11438 18 4.17157 18 3.58579 17.4142C3 16.8284 3 15.8856 3 14V9Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                        />
                        <path opacity="0.5" d="M22 21H2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path opacity="0.5" d="M15 15H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                </a>
            </div>

            <!-- <div class="dropdown shrink-0">
                <div hlMenu>
                    <button
                        type="button"
                        hlMenuButton
                        class="block rounded-full bg-white p-2 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22 10C22.0185 10.7271 22 11.0542 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H13"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                            <path
                                d="M6 8L8.1589 9.79908C9.99553 11.3296 10.9139 12.0949 12 12.0949C13.0861 12.0949 14.0045 11.3296 15.8411 9.79908"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                            <circle cx="19" cy="5" r="3" stroke="currentColor" stroke-width="1.5" />
                        </svg>
                    </button>
                    <ul
                        *hlMenuItems
                        @toggleAnimation
                        class="top-11 w-[300px] !py-0 text-xs text-dark ltr:-right-16 rtl:-left-16 dark:text-white-dark sm:w-[375px] sm:ltr:-right-2 sm:rtl:-left-2"
                    >
                        <li class="mb-5">
                            <div class="relative overflow-hidden rounded-t-md !p-5 text-white">
                                <div
                                    class="bg-[url('/assets/images/menu-heade.jpg')] absolute inset-0 h-full w-full bg-cover bg-center bg-no-repeat"
                                ></div>
                                <h4 class="relative z-10 text-lg font-semibold">Messages</h4>
                            </div>
                        </li>
                        <li *ngFor="let msg of messages">
                            <div class="flex items-center py-3 px-5">
                                <div [innerHTML]="msg.image"></div>
                                <span class="px-3 dark:text-gray-500">
                                    <div class="text-sm font-semibold dark:text-white-light/90">{{msg.title}}</div>
                                    <div>{{msg.message}}</div>
                                </span>
                                <span
                                    class="whitespace-pre rounded bg-white-dark/20 px-1 font-semibold text-dark/60 ltr:ml-auto ltr:mr-2 rtl:mr-auto rtl:ml-2 dark:text-white-dark"
                                    >{{msg.time}}</span
                                >
                                <button type="button" class="text-neutral-300 hover:text-danger" (click)="$event.stopPropagation()">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle opacity="0.5" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
                                        <path
                                            d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                                            stroke="currentColor"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </li>
                        <li *ngIf="messages.length" class="mt-5 border-t border-white-light text-center dark:border-white/10">
                            <div
                                class="group flex cursor-pointer items-center justify-center py-4 px-5 font-semibold text-primary dark:text-gray-400"
                                *hlMenuItem="let menuItem"
                            >
                                <span class="group-hover:underline ltr:mr-1 rtl:ml-1">VIEW ALL ACTIVITIES</span>

                                <svg
                                    class="h-4 w-4 transition duration-300 group-hover:translate-x-1 ltr:ml-1 rtl:mr-1"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M4 12H20M20 12L14 6M20 12L14 18"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </li>
                        <li *ngIf="!messages.length" class="mb-5">
                            <div class="!grid min-h-[200px] place-content-center text-lg hover:!bg-transparent">
                                <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
                                    <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            opacity="0.5"
                                            d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11V5C9.25 4.58579 9.58579 4.25 10 4.25Z"
                                            fill="currentColor"
                                        />
                                        <path
                                            d="M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                </div>
                                No data available.
                            </div>
                        </li>
                    </ul>
                </div>
            </div> -->

            <div #notificationBell class="notification-bell-dropdown shrink-0">
                <button
                    type="button"
                    class="relative block rounded-full bg-card p-2 hover:bg-card hover:text-primary"
                    [attr.aria-expanded]="notificationPanelOpen"
                    aria-controls="notification-panel"
                    aria-label="Notifications"
                    (click)="toggleNotificationPanel()"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19.0001 9.7041V9C19.0001 5.13401 15.8661 2 12.0001 2C8.13407 2 5.00006 5.13401 5.00006 9V9.7041C5.00006 10.5491 4.74995 11.3752 4.28123 12.0783L3.13263 13.8012C2.08349 15.3749 2.88442 17.5139 4.70913 18.0116C9.48258 19.3134 14.5175 19.3134 19.291 18.0116C21.1157 17.5139 21.9166 15.3749 20.8675 13.8012L19.7189 12.0783C19.2502 11.3752 19.0001 10.5491 19.0001 9.7041Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                        />
                        <path
                            d="M7.5 19C8.15503 20.7478 9.92246 22 12 22C14.0775 22 15.845 20.7478 16.5 19"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                        />
                        <path d="M12 6V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    </svg>

                    <span
                        *ngIf="notificationService.unreadCount() > 0"
                        class="absolute -top-1 flex h-[16px] min-w-[16px] items-center justify-center rounded-full bg-danger px-1 text-[10px] font-semibold leading-none text-white ltr:-right-1 rtl:-left-1"
                    >
                        {{ notificationBadgeLabel }}
                    </span>
                </button>
            </div>

            <div class="shrink-0">
                <a
                    routerLink="/ai-assistant"
                    class="group fixed left-4 bottom-4 z-50 flex items-center gap-0 rounded-full bg-white p-1 text-primary ring-1 ring-inset ring-primary ring-offset-0 hover:bg-white sm:relative sm:left-auto sm:bottom-auto sm:gap-1 sm:pr-3 dark:bg-dark/40 dark:ring-white/10 dark:hover:bg-dark/60"
                    [attr.aria-label]="'ai_assistant' | translate"
                >
                    <img class="h-7 w-7 rounded-full" src="/assets/images/mi-copilot.gif" alt="" />
                    <span class="hidden truncate text-xs font-semibold sm:block">{{ 'ai_assistant' | translate }}</span>
                </a>
            </div>

            <div class="dropdown min-w-0 max-w-[min(11rem,32vw)] shrink">
                <div hlMenu class="!block min-w-0">
                    <button
                        id="header-user-menu-trigger"
                        type="button"
                        hlMenuButton
                        class="group relative flex w-full min-w-0 max-w-full items-center gap-2 rounded-full bg-white p-1 hover:bg-white hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
                        [attr.title]="headerDisplayName || null"
                        (click)="toggleDropdown('profile')"
                    >
                        <img
                            *ngIf="showHeaderAvatarImage"
                            id="header-user-menu-trigger-avatar-image"
                            class="h-7 w-7 shrink-0 rounded-full object-cover saturate-50 group-hover:saturate-100"
                            [src]="headerAvatarUrl"
                            alt=""
                            (error)="onHeaderAvatarError()"
                        />
                        <span
                            *ngIf="!showHeaderAvatarImage"
                            id="header-user-menu-trigger-avatar-initials"
                            class="grid h-7 w-7 shrink-0 place-content-center rounded-full bg-success-light text-xs font-semibold text-success dark:bg-success/30 dark:text-success-light"
                            >{{ headerUserInitials }}</span
                        >
                        <span id="header-user-menu-trigger-name" class="min-w-0 flex-1 truncate text-left text-xs font-semibold">{{ headerDisplayName || ' ' }}</span>

                        <div class="shrink-0" [ngClass]="{ 'rtl:rotate-90 -rotate-90': activeDropdown.includes('profile')}">
                            <icon-caret-down />
                        </div>
                    </button>
                    <ul
                        *hlMenuItems
                        id="header-user-menu"
                        @toggleAnimation
                        class="top-11 w-[260px] !py-0 text-foreground ltr:right-0 rtl:left-0"
                    >
                        <li class="px-3 pt-3">
                            <div id="header-user-menu-card" class="flex min-w-0 items-center justify-between rounded-lg border border-border px-3 py-3">
                                <div class="min-w-0 flex-1 ltr:pr-3 rtl:pl-3">
                                    <h4 id="header-user-menu-name" class="truncate text-sm font-semibold text-foreground" [attr.title]="headerDisplayName">{{ headerDisplayName }}</h4>
                                    <p id="header-user-menu-email" class="truncate text-xs text-muted-foreground" [attr.title]="headerUserEmail">{{ headerUserEmail }}</p>
                                </div>
                                <div class="shrink-0 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 p-0.5">
                                    <img
                                        *ngIf="showHeaderAvatarImage"
                                        id="header-user-menu-card-avatar-image"
                                        class="h-10 w-10 rounded-full border-2 border-white object-cover dark:border-[#1b2e4b]"
                                        [src]="headerAvatarUrl"
                                        alt=""
                                        (error)="onHeaderAvatarError()"
                                    />
                                    <span
                                        *ngIf="!showHeaderAvatarImage"
                                        id="header-user-menu-card-avatar-initials"
                                        class="grid h-10 w-10 place-content-center rounded-full border-2 border-white bg-success-light text-sm font-semibold text-success dark:border-[#1b2e4b] dark:bg-success/30 dark:text-success-light"
                                        >{{ headerUserInitials }}</span
                                    >
                                </div>
                            </div>
                        </li>
                        <li>
                            <a id="header-user-menu-profile-link" routerLink="/settings/profile" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                                    <path
                                        opacity="0.5"
                                        d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>
                                Profile
                            </a>
                        </li>
                        <li *ngIf="isWorkspaceAdmin">
                            <a id="header-user-menu-workspace-link" routerLink="/settings/general" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.5"
                                        d="M3 10H21M3 10V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V10M3 10V8C3 6.89543 3.89543 6 5 6H8M21 10V8C21 6.89543 20.1046 6 19 6H16"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M12 13V16"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                </svg>
                                Workspace
                            </a>
                        </li>
                        <li class="border-t border-[#eee] pt-1 dark:border-white-light/10">
                            <span class="block px-4 py-2 text-xs text-black/50 dark:text-white-dark/50">Need Assistance ?</span>
                        </li>
                        <li>
                            <a id="header-user-menu-whats-new-link" routerLink="/changelog" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <icon-megaphone class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                                What's new
                                <span
                                    *ngIf="changelogService.hasUnseenRelease()"
                                    class="ml-auto inline-block h-2 w-2 shrink-0 rounded-full bg-primary"
                                    aria-label="New release"
                                ></span>
                            </a>
                        </li>
                        <li>
                            <a id="header-user-menu-support-link" routerLink="/help-center" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 11V13C3 16.2998 3 17.9497 4.02513 18.9749C5.05025 20 6.70017 20 10 20H14C17.2998 20 18.9497 20 19.9749 18.9749C21 17.9497 21 16.2998 21 13V11"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M12 20V10"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M7.5 10C7.5 7.51472 9.51472 5.5 12 5.5C14.4853 5.5 16.5 7.51472 16.5 10"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                </svg>
                                Support
                            </a>
                        </li>
                        <li>
                            <a id="header-user-menu-faq-link" href="javascript:;" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12 3L4.5 6.5V11.5C4.5 16.1944 7.53757 20.1944 12 21.5C16.4624 20.1944 19.5 16.1944 19.5 11.5V6.5L12 3Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M12 8V13"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <circle cx="12" cy="16" r="0.75" fill="currentColor" />
                                </svg>
                                FAQ
                            </a>
                        </li>
                        <li>
                            <a id="header-user-menu-terms-link" href="javascript:;" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12 3L4.5 6.5V11.5C4.5 16.1944 7.53757 20.1944 12 21.5C16.4624 20.1944 19.5 16.1944 19.5 11.5V6.5L12 3Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M9 12L11 14L15 10"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                Terms &amp; Conditions
                            </a>
                        </li>
                        <li>
                            <a id="header-user-menu-privacy-link" href="javascript:;" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.5"
                                        d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                </svg>
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a id="header-user-menu-help-center-link" routerLink="/help-center" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" opacity="0.5" />
                                    <path
                                        d="M12 17V17.01"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M12 14C12 11.5 14.5 11.5 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                </svg>
                                Help Center
                            </a>
                        </li>
                        <li>
                            <a id="header-user-menu-plan-bills-link" routerLink="/plan-bills" *hlMenuItem="let menuItem" class="dark:hover:text-white">
                                <icon-list-check class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                                Plan &amp; Bills
                            </a>
                        </li>
                        <li class="border-t border-[#eee] dark:border-white-light/10">
                            <a id="header-user-menu-sign-out-link" href="#" *hlMenuItem="let menuItem" class="!py-3 dark:hover:text-white" (click)="signOut($event)">
                                <svg
                                    class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15 12H3M21 12H17M17 12L13 8M17 12L13 16"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M8 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H8"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                Sign Out
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- horizontal menu -->
    <ul
        class="horizontal-menu hidden border-t border-[#ebedf2] bg-white py-1.5 px-4 font-semibold text-black rtl:space-x-reverse dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:space-x-1.5 xl:space-x-2"
    >
        <li class="menu nav-item relative">
            <a routerLink="/dashboard" class="nav-link">
                <div class="flex items-center">
                   <icon-menu-dashboard class="shrink-0" />
                    <span class="px-2">{{ 'Dashboard' | translate }}</span>
                </div>
            </a>
        </li>
        <li class="menu nav-item relative">
            <a routerLink="/leads" class="nav-link">
                <div class="flex items-center">
                   <icon-users class="shrink-0" />
                    <span class="px-2">{{ 'Leads' | translate }}</span>
                </div>
            </a>
        </li>
        
    </ul>

    <div
        *ngIf="notificationPanelOpen"
        #notificationPanel
        id="notification-panel"
        class="fixed right-3 top-[3.75rem] z-[1051] flex h-[min(560px,calc(100dvh-5rem))] w-[380px] max-w-[calc(100vw-1.5rem)] flex-col sm:right-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="notification-panel-title"
    >
        <app-notification-dropdown-panel (closed)="closeNotificationPanel()" />
    </div>
</div>
